<template>
    <div class="pay-body">
        <backindex :msg="payMsg"></backindex>
        <div class="style-area">
            {{msg}}
        </div>
        <div class="logout-btn">
            <div class="logout-click" @click="go.goAfterRecharge">點擊返回</div>
        </div>
        <div class="pay-bottom">
            <pagebottom></pagebottom>
        </div>
    </div>
</template>

<script>
    import backindex from "@/components/common/backindex"
    import pagebottom from "@/components/common/pagebottom"
    export default {
        name: "little",
        components:{
            backindex,
            pagebottom
        },
        mounted: function() {
            this.payMsg = this.$t("charge");
        },
        data(){
            return{
                payMsg:"在线储值",
                msg:this.$route.query.msg,
            }
        },
        methods: {
        }
    }
</script>

<style scoped>
    .more-pay-title{
        width: 100%;
        height: 1rem;
        border-top: 0.02rem solid #e6e6e6;
        box-sizing: border-box;
        padding: 0 0.4rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: 700;
        font-size: 0.34em;
        color: #4d4d4d;
    }
    .pay-body{
        width: 100%;
        height: auto;
    }
    .downloadImg{
        width: 50%;
        float: left;
    }
    .downloadImg img{
        width: 80%;
        margin: 0.4em 10%
    }
    .pay-bottom{
        width: 100%;
        margin-top: 3em;
        left: 0;
        bottom: 0;
    }
    .pay-title{
        width: 100%;
        height: 1.12rem;
        border-bottom: 0.02rem solid #e6e6e6;
        box-sizing: border-box;
        padding: 0 0.4rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: 700;
    }
    .pay-user,.pay-coin{
        font-size: 0.28rem;
        line-height: 0.28rem;
        color: #4d4d4d;
    }
    .pay-coin span{
        color: #ff1f4f;
    }
    .pay-cost{
        width: 100%;
        padding: 0.4rem;
        box-sizing: border-box;
        font-size: 0.3rem;
        line-height: 0.3rem;
        color: #666666;
        font-weight: 700;
    }
    .pay-style{
        width: 100%;
        padding: 0 0 0.4rem 0.4rem;
        box-sizing: border-box;
        font-size: 0.3rem;
        line-height: 0.3rem;
        color: #666666;
        font-weight: 700;
        display: flex;
        align-items: center;
    }
    /*存储方式*/
    /* .style-area{
        width: auto;
        box-sizing: border-box;
        border: 0.01rem solid #808080;
        border-radius: 0.08rem;
        display: flex;
        position: relative;
    } */
    .style-left{
        padding: 0.12rem 0.26rem;
        font-size: 0.28rem;
        line-height: 0.28rem;
        color: #666666;
    }
    .coin-left{
        padding: 0.14rem 0.64rem;
        font-size: 0.26rem;
        line-height: 0.26rem;
        color: #666666;
    }
    .style-right{
        width: 0.4rem;
        border-left: 0.01rem solid #808080;
        padding: 0.18rem 0;
    }
    .style-right img{
        display: block;
        width: 0.18rem;
        height: 0.14rem;
        margin: 0 auto;
    }
    .style-options{
        width: 100%;
        height: 2rem;
        border: 0.01rem solid #808080;
        border-top: none;
        background: #FFFFFF;
        text-align: center;
        font-size: 0.28rem;
        line-height: 0.28rem;
        color: #666666;
        position: absolute;
        left: -0.01rem;
        top: 100%;
        z-index: 99;
        padding-top: 0.08rem;
        box-sizing: border-box;
        border-radius: 0 0 0.08rem 0.08rem;
        animation: show 0.6s;
        overflow-y: auto;
    }
    .options-item{
        padding: 0.1rem 0;
        overflow: hidden;
    }
    .options-select{
        background: #e6e6e6;
    }
    /*下拉展示动画*/
    @keyframes show {
        from {
            height: 0;
        }
        to {
            height: 2rem;
        }
    }
    .option-img{
        transform: rotate(180deg);
        transition: all 0.4s;
    }
    /*获得{{$t("coin")}}*/
    .get-coin{
        width: 100%;
        padding: 0 0.4rem 1rem;
        box-sizing: border-box;
        font-size: 0.3rem;
        line-height: 0.3rem;
        color: #666666;
        font-weight: 700;
    }
    .get-coin span{
        color: #ff1f4f;
    }
    .pay-btn{
        width: 60%;
        box-sizing: border-box;
        padding: 0 0.2rem;
        margin: 0.5em auto;
    }
    .pay-click{
        width: 100%;
        height: 0.84rem;
        font-size: 0.32rem;
        color: #FFFFFF;
        line-height: 0.84rem;
        background: #ff1f4f;
        border-radius: 0.08rem;
        text-align: center;
        font-weight: 700;
    }
    .style-area{
        width: 100%;
        height: auto;
        padding: 1rem 0 0 0.4rem;
        font-size: 0.5rem;
        text-align: center;
    }
    .style-item{
        width: 3.16rem;
        height: 0.82rem;
        background: #ff1f4f;
        border-radius: 0.08rem;
        box-sizing: border-box;
        text-align: center;
        line-height: 0.82rem;
        color: #ffffff;
        font-size: 0.32rem;
    }
    .style-item{
        float: left;
        margin: 0 0.4rem 1rem 0;
    }
    .logout-btn{
        width: 90%;
        margin: 1em auto;
        box-sizing: border-box;
        padding: 0 0.2rem;
    }
    .logout-click{
        width: 100%;
        height: 0.84rem;
        font-size: 0.32rem;
        color: #FFFFFF;
        line-height: 0.84rem;
        background: #ff1f4f;
        border-radius: 0.08rem;
        text-align: center;
        font-weight: 700;
    }
</style>


// WEBPACK FOOTER //
// src/components/pay/cardresult.vue